import i18n from '@/i18n';

export default [
  {
    path: '/canned-replies',
    name: 'canned-replies',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'comment',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('canned_replies')
    },
    // route level code-splitting
    component: () =>
      import('../../views/cannedReplies/Index'),
    children: [
      {
        path: 'new',
        name: 'canned-replies-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'comment',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('canned_replies'),
        },
        component: () => import('../../views/cannedReplies/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'canned-replies-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'comment',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('canned_replies'),
        },
        component: () => import('../../views/cannedReplies/Edit.vue'),
      },
    ],
  },
];
